import isArray from "@homer.utility/validator.isarray";
import isFalsy from "@homer.utility/validator.isfalsy";
import isObject from "@homer.utility/validator.isobject";
import { diff as dodSimple, detailedDiff as dodDetailed } from "deep-object-diff";

const isEqual = (previous, current) => {
    previous = isFalsy(previous) ? (isArray(current) ? [] : isObject(current) ? {} : null) : previous;
    current = isFalsy(current) ? (isArray(previous) ? [] : isObject(previous) ? {} : null) : current;

    if ((isArray(previous) && !isArray(current)) || (isObject(previous) && !isObject(current))) {
        throw new TypeError("arguments `previous` and `current` must be of exactly equal type");
    }

    return Object.keys(dodSimple(previous, current)).length === 0;
};

const diff = (previous, current) => {
    previous = isFalsy(previous) ? (isArray(current) ? [] : isObject(current) ? {} : null) : previous;
    current = isFalsy(current) ? (isArray(previous) ? [] : isObject(previous) ? {} : null) : current;

    if ((isArray(previous) && !isArray(current)) || (isObject(previous) && !isObject(current))) {
        throw new TypeError("arguments `previous` and `current` must be of exactly equal type");
    }

    return dodDetailed(previous, current);
};

export default { isEqual, diff };
